import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Survey from "../pages/survey/page";
import ConnectWallet from "../pages/connect-wallet/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Survey />,
  },
  {
    path: "/connect-wallet",
    element: <ConnectWallet />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
